export default "__VITE_ASSET__BlcAxPmy__"